import { useMutation } from '@tanstack/react-query'
import { toast } from 'react-toastify'
import { useAuth } from 'src/contexts/auth'
import { SaleController } from 'src/controllers/sale.controller'
import { UpdateSaleDTO } from 'src/dto/sale'

const saleController = new SaleController()

export function useUpdateSale() {
  const { userFarm: farmId } = useAuth()

  return useMutation({
    mutationKey: ['updateSale', farmId],
    mutationFn: (updateSaleDto: UpdateSaleDTO) => saleController.updateSale(farmId!, updateSaleDto),
    onError: () => {
      toast.error('Erro ao atualizar venda.')
    }
  })
}
